import { axios } from '@/utils/request'
import qs from 'qs'
let moduleName="userCommissionAgreement";

export function selectAll(parameter){
  console.log("params:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'get',
    params: parameter,
    paramsSerializer: params => {
      return qs.stringify(params, { indices: false })
    }
  })
}

export function selectByLogin(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}/selectByLogin`,
    method: 'get',
  })
}

export function confirmInfo(parameter){
  console.log("data:",parameter)
  return axios({
    url: `/ws/${moduleName}`,
    method: 'put',
    data:parameter
  })
}


export default {
  selectAll,
  selectByLogin,
  confirmInfo,
}